import { Component, ComponentRef, Input, OnInit, ViewChild } from '@angular/core';
import { Widget } from '../widget';
import { WidgetComponent } from '../widgets/widget-component';
import { WidgetAnchorDirective } from '../directives/widget-anchor/widget-anchor.directive';

@Component({
  selector: 'lms-widget-container',
  templateUrl: './widget-container.component.html',
  styleUrls: ['./widget-container.component.scss']
})
export class WidgetContainerComponent implements OnInit {
  @Input() widget: Widget;
  @ViewChild(WidgetAnchorDirective, { static: true }) public widgetAnchor: WidgetAnchorDirective;

  constructor() {}

  ngOnInit() {
    this.loadWidgetComponent();
  }

  loadWidgetComponent() {
    const componentRef: ComponentRef<any> = this.widgetAnchor.viewContainerRef.createComponent(this.widget.component);
    (componentRef.instance as WidgetComponent).data = this.widget.data;
  }
}
